/**
 * PolyVideo Constants
 * 
 * Design system colors, styling constants, and configuration values
 */

// Brand Colors (from README: #1d2b3a and #2b97d4)
export const COLORS = {
  // Primary brand colors
  PRIMARY_DARK: '#1d2b3a',
  PRIMARY_BLUE: '#2b97d4',
  
  // Grayscale
  WHITE: '#ffffff',
  LIGHT_GRAY: '#f5f5f5',
  GRAY: '#888888',
  DARK_GRAY: '#333333',
  BLACK: '#000000',
  
  // Chart colors (Polymarket-inspired)
  CHART_GREEN: '#00d395',
  CHART_RED: '#ff4976',
  CHART_BLUE: '#2b97d4',
  CHART_YELLOW: '#ffc107',
  
  // UI States
  SUCCESS: '#00d395',
  ERROR: '#ff4976',
  WARNING: '#ffc107',
  INFO: '#2b97d4',
  
  // Background variations
  BG_DARK: '#0f1419',
  BG_DARKER: '#0a0e12',
  BG_LIGHT: '#f8f9fa',
  
  // Border/Shadow
  BORDER: 'rgba(255, 255, 255, 0.1)',
  SHADOW: 'rgba(0, 0, 0, 0.15)',
};

// View States
export const VIEW_STATES = {
  INPUT: 'input',
  LOADING: 'loading',
  USAGE: 'usage',
  ERROR: 'error'
};

// Shadow styles (radial box shadows for Notion/Polymarket aesthetic)
export const SHADOWS = {
  SMALL: '0 2px 8px rgba(0, 0, 0, 0.1)',
  MEDIUM: '0 4px 16px rgba(0, 0, 0, 0.12)',
  LARGE: '0 8px 32px rgba(0, 0, 0, 0.15)',
  RADIAL_SMALL: '0 0 0 1px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.1)',
  RADIAL_MEDIUM: '0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.12)',
  RADIAL_LARGE: '0 0 0 1px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(0, 0, 0, 0.15)',
};

// Border Radius
export const BORDER_RADIUS = {
  SMALL: '4px',
  MEDIUM: '8px',
  LARGE: '12px',
  XLARGE: '16px',
};

// Spacing
export const SPACING = {
  XS: '4px',
  SM: '8px',
  MD: '16px',
  LG: '24px',
  XL: '32px',
  XXL: '48px',
};

// Font Sizes
export const FONT_SIZES = {
  XS: '12px',
  SM: '14px',
  MD: '16px',
  LG: '18px',
  XL: '24px',
  XXL: '32px',
  XXXL: '48px',
};

// Transitions
export const TRANSITIONS = {
  FAST: '0.15s ease',
  NORMAL: '0.3s ease',
  SLOW: '0.5s ease',
};

// Configuration defaults
export const DEFAULTS = {
  MIN_TOKEN_AMOUNT: 10,
  EXTREMA_THRESHOLD: 0.02, // 2%
  TOP_TRADES_COUNT: 30,
};

// Error messages
export const ERROR_MESSAGES = {
  INVALID_URL: 'Please enter a valid URL',
  INVALID_TIME: 'Please enter valid start and end times',
  API_ERROR: 'Failed to fetch data. Please try again.',
  NO_DATA: 'No data found for the specified time range',
};

const constants = {
  COLORS,
  VIEW_STATES,
  SHADOWS,
  BORDER_RADIUS,
  SPACING,
  FONT_SIZES,
  TRANSITIONS,
  DEFAULTS,
  ERROR_MESSAGES,
};

export default constants;

